import React, { useState } from "react";
import ConfirmDialog from "../../components/Base/ConfirmDialog";
import { updateSolanaStatus } from "../../request/config";
import { alertSuccess } from "../../store/actions/alert";
import { useDispatch } from "react-redux";

const EnableSolanaFeatureForm = (props: any) => {
  const {
    isOpenEditPopupSolana,
    setIsOpenEditPopupSolana,
    onConfirmCalcualte,
    disableButton,
    fetchFlags,
    solanaFlag,
    solnaFeatFlag,
    setSolanaFeatFlag,
    displaySoalnaLabel,
    localSolanaFlag,
  } = props;
  const dispatch = useDispatch();

  const [previousSortFlag, setPreviousSortFlag] = useState(solnaFeatFlag);

  const handleSubmitPopup = async () => {
    const name = solanaFlag?.name;
    try {
      const response = await updateSolanaStatus
      (
        { name, value: localSolanaFlag },
        solanaFlag?.id
      );

      // console.log(" Solana Enable/Disable >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",response)

      fetchFlags();
      dispatch(alertSuccess("Successfull"));
      setIsOpenEditPopupSolana(false);
      setSolanaFeatFlag(response.data.value);
    } catch (e) {
      console.log(e, "error");
    }
  };

  const handleCancel = () => {
    setIsOpenEditPopupSolana(false);
    setSolanaFeatFlag(solnaFeatFlag);
  };
  return (
    <ConfirmDialog
      title={displaySoalnaLabel ? "Enable Solana Feature" : "Disable Solana Feature"}
      open={isOpenEditPopupSolana}
      confirmLoading={disableButton}
      onConfirm={handleSubmitPopup}
      onCancel={handleCancel}
    >
      <div>Are you sure you want to enable solana feature?</div>
    </ConfirmDialog>
  );
};

export default EnableSolanaFeatureForm;
